// removed by extract-text-webpack-plugin
module.exports = {"content":"TogglePresenting-content","title":"TogglePresenting-title","buttonIcon":"TogglePresenting-buttonIcon","buttonLabel":"TogglePresenting-buttonLabel","errorMessage":"TogglePresenting-errorMessage","icon":"TogglePresenting-icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TogglePresenting.scss
// module id = 755
// module chunks = 0